export default "mutation userBatchChooseCourse($batchChoose: UserBatchChooseCourseRequest) {\n  userBatchChooseCourse(batchChoose: $batchChoose) \n}";